<fieldset [formGroup]="signatureForm" [hidden]="(visible$ | async) === false">
    <ng-container *ngrxLet="signature$; let signature">
        <div class="row mb-md-3 mb-2">
            <div class="col">
                <p>{{ signature.description }}</p>
            </div>
        </div>
        @if (signature.choices) {
            <pace-forms-choices [choices]="signature.choices" [formControl]="radioControl"></pace-forms-choices>
        }
        <div class="row mb-md-3 mb-2">
            <span class="col-md-2 col-form-label col-4 text-start">{{ signature.label }}</span>
            <div class="col-md-auto col-12">
                <!-- we need to add the height and width of the canvas directly in the html.
        https://stackoverflow.com/questions/51805385/not-getting-actual-canvas-height-and-width-and-fillrect-is-blurred-out-->
                <canvas
                    #signatureCanvas
                    [height]="120"
                    [ngClass]="{
                        'ng-invalid': signaturePad && signaturePad.isEmpty && firstNameControl.enabled,
                        disabled: firstNameControl.disabled,
                    }"
                    [width]="300"
                    class="cse-signature-canvas signature-canvas"
                ></canvas>
            </div>
            <div class="col-md-auto col-3 pt-md-0 pt-3">
                <button
                    (click)="clearSignature()"
                    [disabled]="signature.disabled || (readOnly$ | async)"
                    class="btn btn-secondary btn-lg"
                    translate="F4M_SUMMARY_MODAL_CLEAR_LABEL"
                    type="button"
                ></button>
            </div>
            @if (displayHistoryButton$ | async) {
                <div class="col-auto pt-sm-0 pt-4 ms-auto d-flex align-items-center">
                    <pace-forms-history-button [uniqueId]="signature.uniqueId"></pace-forms-history-button>
                </div>
            }
        </div>
        <div class="row mb-md-3 mb-2">
            <label class="col-md-2 col-form-label col-4 text-start" for="{{ signature.nameXmlId }}-firstName"
                >First Name:</label
            >
            <div class="col-md-10 col-12">
                <input
                    [formControl]="firstNameControl"
                    class="form-control input-md name-input"
                    id="{{ signature.nameXmlId }}-firstName"
                    type="text"
                />
            </div>
        </div>
        <div class="row mb-md-3 mb-2">
            <label class="col-md-2 col-form-label col-4 text-start" for="{{ signature.nameXmlId }}-lastName"
                >Last Name:</label
            >
            <div class="col-md-10 col-12">
                <input
                    [formControl]="lastNameControl"
                    class="form-control input-md name-input"
                    id="{{ signature.nameXmlId }}-lastName"
                    type="text"
                />
            </div>
        </div>
        @if (showEmailField$ | async) {
            <div class="row mb-md-3 mb-2">
                <label class="col-md-2 col-form-label col-4 text-start" for="{{ signature.nameXmlId }}-email"
                    >Email:</label
                >
                <div class="col-md-10 col-12">
                    <input
                        [formControl]="emailControl"
                        class="form-control input-md name-input"
                        id="{{ signature.nameXmlId }}-email"
                        type="text"
                    />
                </div>
            </div>
        }
    </ng-container>
</fieldset>
